
















































































































































































































import Component from "vue-class-component";
import BaseComponent from "../../../components/shared/BaseComponent.vue";
import ObjectList from "../../../components/shared/forms/ObjectList.vue";
import TableRowSkeleton from "../../../components/shared/skeletons/TableRowSkeleton.vue";
import SvgResultsEmpty from "../../../assets/img/ResultsEmpty.vue";
import SideModal from "../../../components/shared/modals/SideModal.vue";
import ErrorModal from "@/components/shared/modals/ErrorModal.vue";
import PageTitle from "../../../components/shared/navigation/PageTitle.vue";
import Modal from "../../../components/shared/modals/Modal.vue";
import { PeriodRequest } from "@/application/contracts/app/shared/PeriodRequest";
import ErrorModalComponent from "@/components/shared/modals/NewErrorModal.vue";
import { Period } from "@/application/enums/app/common/Period";
import { SupplierBranchDto } from "@/application/dtos/app/contacts/SupplierBranchDto";
import services from "@/services";

@Component({
  components: {
    Modal,
    SideModal,
    ObjectList,
    TableRowSkeleton,
    SvgResultsEmpty,
    ErrorModal,
    PageTitle
  }
})
export default class SuppliersList extends BaseComponent {
  $refs!: {
    uploadTicketsModal: Modal;
    errorModal: ErrorModalComponent;
  };
  private items = [] as SupplierBranchDto[];
  private adding: boolean = false;
  private periodRequest: PeriodRequest = {
    period: Period.ALL,
    withDetails: true
  };
  mounted() {
    this.reload(this.periodRequest);
  }
  async reload(periodRequest?: PeriodRequest) {
    if (periodRequest) {
      this.periodRequest = periodRequest;
    }
    this.items = [];
    this.loading = true;
    services.suppliers
      .getAllProveedores(this.periodRequest)
      .then((response: SupplierBranchDto[]) => {
        // console.log(JSON.stringify(response))
        this.items = response;
      })
      .catch(error => {
        this.$refs.errorModal.show(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  deleted(data: SupplierBranchDto) {
    this.items = this.items.filter(f => f.id !== data.id);
  }
  canceled() {
    // console.log("canceled");
  }
  added(data: SupplierBranchDto) {
    // console.log("added data:" + JSON.stringify(data));
    this.items.push(data);
  }
  saved(data: SupplierBranchDto) {
    const idx = this.items.findIndex(f => f.id === data.id);
    this.items[idx] = data;
  }
  get orderedItems(): SupplierBranchDto[] {
    if (!this.items) {
      return [];
    }
    return this.items.sort((x, y) => {
      if (x.taxId && y.taxId) {
        return (x.taxId > y.taxId ? 1 : -1) ?? 1;
      }
      return 1;
    });
  }
}
